export class ProgressStates {
  complete: boolean;
  inProgress: boolean;
}
